module.exports = __webpack_public_path__ + "static/img/11.c7fbc0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/11.png
// module id = KEZ5
// module chunks = 0